const DANGEROUS_TAGS_REGEX =
  /<\s*(script|style|iframe|object|embed|form)\b[\s\S]*?(<\s*\/\s*\1\s*>|$)/gi;
const EVENT_HANDLER_REGEX = /\s+on\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi;
const JS_PROTOCOL_REGEX =
  /(\s(?:href|src|xlink:href)\s*=\s*)(["']?)\s*javascript:[^"'\s>]*/gi;

export const sanitizeHtml = (html?: string): string => {
  if (!html) return '';

  return html
    .replace(DANGEROUS_TAGS_REGEX, '')
    .replace(EVENT_HANDLER_REGEX, '')
    .replace(JS_PROTOCOL_REGEX, '$1$2');
};
